import { Directive, Input, ElementRef } from '@angular/core';
export class AccordionToggleDirective {
   accordionComponent;
/**
 * \@method constructor
 * @param {?} elementRef
 */
constructor(
public elementRef: ElementRef
  ) {}
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[mkAccordionToggle]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'accordionComponent': [{ type: Input, args: ['mkAccordionToggle', ] },],
};
}

function AccordionToggleDirective_tsickle_Closure_declarations() {
/** @type {?} */
AccordionToggleDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
AccordionToggleDirective.ctorParameters;
/** @type {?} */
AccordionToggleDirective.propDecorators;
/** @type {?} */
AccordionToggleDirective.prototype.accordionComponent;
/** @type {?} */
AccordionToggleDirective.prototype.elementRef;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
